module.exports = __webpack_public_path__ + "static/media/messaging-logo.da24ad8f.png";